import { createApp } from 'vue';
import { convexVue } from 'convex-vue';
import App from './App.vue';
import { initializeAuthTokenSession, initializeRecorderBootstrapSession } from './convex/auth';
import { createAppRouter } from './router';
import './styles/tailwind.css';

const convexUrl = import.meta.env.VITE_CONVEX_URL;

if (!convexUrl) {
  throw new Error('Missing VITE_CONVEX_URL. Run `pnpm exec convex dev` and ensure .env.local is loaded.');
}

await initializeRecorderBootstrapSession();
initializeAuthTokenSession();

const app = createApp(App);
const router = createAppRouter();

app.use(router);
app.use(convexVue, { url: convexUrl });
app.mount('#app');
